<app-base-modal
  [title]="createComponentModalTitle"
>
  <form
    class="create-component-form"
    [formGroup]="componentForm"
  >
    @for (field of createComponentFormFields; track $index) {
      <mat-form-field appearance="outline">
        <mat-label>
          {{ field.label }}
        </mat-label>
        @switch (field.type) {
          @case ('text') {
            <input
              matInput
              [type]="field.type"
              [formControlName]="field.fieldName"
            >
          }
          @case ('tel') {
            <input
              appPhoneMask
              matInput
              [type]="field.type"
              [formControlName]="field.fieldName"
            >
          }
          @case ('email') {
            <input
              appEmailMask
              matInput
              [type]="field.type"
              [formControlName]="field.fieldName"
            >
          }
        }
      </mat-form-field>
    }
  </form>
  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      type="button"
      class="save-button"
      [disabled]="componentForm.invalid"
      (click)="handleCreate()"
    >
      Создать
    </button>
    <button
      mat-button
      color="warn"
      type="button"
      (click)="closeDialog('cancel')"
    >
      Отмена
    </button>
  </div>
</app-base-modal>
